import { render } from "./schoolMain.vue?vue&type=template&id=4faf6e10&scoped=true"
import script from "./schoolMain.vue?vue&type=script&lang=js"
export * from "./schoolMain.vue?vue&type=script&lang=js"

import "./schoolMain.vue?vue&type=style&index=0&id=4faf6e10&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4faf6e10"]])

export default __exports__